import React from 'react';
import { useNavigate } from 'react-router-dom';
import useNavigationHistory from '../../hooks/useNavigationHistory';

/**
 * BackButton component that only shows when there's navigation history available
 * @param {Object} props - Component props
 * @param {string} props.className - Additional CSS classes
 * @param {Object} props.style - Inline styles
 * @param {string} props.text - Button text (default: "Back")
 * @param {Function} props.onClick - Custom click handler (overrides default navigation)
 */
const BackButton = ({ 
  className = '', 
  style = {}, 
  text = 'Back', 
  onClick 
}) => {
  const navigate = useNavigate();
  const canGoBack = useNavigationHistory();

  // Don't render if there's no navigation history
  if (!canGoBack) {
    return null;
  }

  const handleClick = () => {
    if (onClick) {
      onClick();
    } else {
      navigate(-1);
    }
  };

  const defaultStyle = {
    display: 'flex',
    alignItems: 'center',
    gap: '6px',
    padding: '6px 12px',
    backgroundColor: '#6c757d',
    color: 'white',
    border: 'none',
    borderRadius: '4px',
    cursor: 'pointer',
    fontSize: '14px',
    textDecoration: 'none',
    ...style
  };

  return (
    <button
      onClick={handleClick}
      className={className}
      style={defaultStyle}
      onMouseOver={(e) => e.target.style.backgroundColor = '#5a6268'}
      onMouseOut={(e) => e.target.style.backgroundColor = style.backgroundColor || '#6c757d'}
    >
      <i className="fas fa-arrow-left"></i>
      {text}
    </button>
  );
};

export default BackButton;